import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { BaseComponent } from './base.component';
import { Situacoes, MotivoJustificativa } from 'app/entity/enumeraveis';
import { SelectItem } from 'primeng/primeng';
import { environment } from '../../environments/environment';

@Component({
    selector: 'base-list-filter',
    template: `
    <form [formGroup]="filtro" novalidate>
        <div class="ui-g-14 ui-md-12 ui-lg-12 form-group">
        <form-text *ngIf="!ehNumero" class="ui-g-12 ui-md-6 ui-lg-4" label="Digite aqui sua consulta" formControlName="query"></form-text>
        <form-number *ngIf="ehNumero" class="ui-g-12 ui-md-6 ui-lg-4" label="Pesquisar por exercicio" formControlName="query"></form-number>
        <form-multi-select class="ui-g-12 ui-md-6 ui-lg-4" *ngIf="isGerenciamentoJustificativas" 
            formControlName="ids_motivos_justificativas"
            [options]="listaMotivosJustificativas | formatSelectItem:'value': 'label'"
            placeholder="Motivo Justificativa"></form-multi-select>
        <form-multi-select class="ui-g-12 ui-md-6 ui-lg-4" *ngIf="isGerenciamentoJustificativas" formControlName="ids_situacoes"
            [options]="listaSituacao | formatSelectItem:'value': 'label'" placeholder="Situação"></form-multi-select>
        <div class="ui-g-12  ui-md-12"></div>
        </div>
    </form>

    <div class="ui-g-5 ui-md-2 ui-lg-3">
        <button pButton *ngIf="isGerenciamentoJustificativas" type="button" label="Limpar" (click)="limpar()"
        class="ui-button-white"></button>
    </div>

    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 6%;" *ngIf="btnEnabled">
        <button pButton type="button" [label]="btnLabel" class="ui-button-mandalay" icon="ui-icon-plus" [disabled]="disabledBtnAdicionar" (click)="adicionar()" ></button>
    </div>

    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 20px;" *ngIf="btnEnabled">
        <button pButton type="button" label="Consultar" class="ui-button" icon="ui-icon-search" (click)="consultar($event)" ></button>
    </div>

    <div class="ui-g-10 ui-md-4 ui-lg-3" style="float: right; margin-right: 6%;" *ngIf="!btnEnabled">
        <button pButton type="button" label="Consultar" class="ui-button" icon="ui-icon-search" (click)="consultar($event)" ></button>
    </div>
    `})
export class BaseListFilterComponent extends BaseComponent {
    @Input() btnEnabled : boolean = true;
    @Input() labelPersonalizada : string = "Digite aqui sua consulta";
    @Input() disabledBtnAdicionar : boolean;
    @Input() btnLabel : string = "Adicionar";
    @Input() ehNumero : boolean = false;
    @Input() filtro : FormGroup;
    @Input() listagem : DatatableComponent;
    @Input() isGerenciamentoJustificativas : boolean = false;
    @Input() listaMotivosJustificativas: any[] = [];
    @Input() listaSituacao: SelectItem[] = [];
    currentUrl: string = this.router.url;
    baseUrl = `${environment.apiEndpoint}`;

    init() {
        if (this.isGerenciamentoJustificativas) {
            this.loadListAsEnum(this.listaSituacao, Situacoes);
            this.loadListAsEnum(this.listaMotivosJustificativas, MotivoJustificativa);
        }
    }

    consultar(event){
        const params = new URLSearchParams();
        const formValue = this.filtro.value;
        this.listagem.pDatatableComponent.first = 0;

        for (const key in formValue) {
            if(formValue[key] !== null)
            params.append(key, formValue[key]);
        }
        if(this.router.url.split('/')[2] == 'curso-prestacao-conta' || this.router.url.split('/')[2] == 'evento-prestacao-conta'){
            sessionStorage.setItem('turma_edicao',this.router.url.split('/')[2]);
            sessionStorage.setItem('filtro_turma_edicao',params.toString());
        }else{
            sessionStorage.setItem('funcionalidade',this.router.url.split('/')[2]);
            sessionStorage.setItem('filtro',params.toString());
        }
        this.listagem.url = this.addNecessaryParams(params, this.listagem.url);
        this.listagem.refresh();
    }

    addNecessaryParams(filter: any = null, url: string ): string {
        try {
            const query = sessionStorage.getItem('filtro');
            const lotacao = localStorage.getItem('lotacao') || '';
            const params = new URLSearchParams();
    
            const filtroAtualizado = { ...filter, id_lotacao: lotacao };
            this.addParams(params, filtroAtualizado);
    
            if (query) {
                const parametrosQuery = this.obterParametros(query);
                parametrosQuery.id_lotacao = lotacao;
                this.addParams(params, parametrosQuery);
            }
    
            return `${url}/?${params.toString()}`;
        } catch (error) {
            console.error('Error generating URL:', error);
            return '';
        }
    }
      
    private addParams(params: URLSearchParams, filter: any): void {
        Object.keys(filter).forEach(key => params.set(key, filter[key]));
    }
      
    obterParametros(query: string): any {
        try {
            const parametros = query.split('&')
                .map(str => {
                    const [key, value] = str.split('=');
                    return { [key]: decodeURIComponent(value) };
                })
                .reduce((prev, curr) => ({ ...prev, ...curr }), {});
    
            return this.processarParametros(parametros);
  
        } catch (error) {
            console.error('Error processing query parameters:', error);
            return {};
        }
    }
      
    private processarParametros(parametros: any): any {
        Object.keys(parametros).forEach(key => {
            let valor = parametros[key];
    
            if (valor.indexOf('%2C') !== -1) {
                parametros[key] = valor.split('%2C');
                return;
            }
    
            valor = valor.replace('%2F', '/').split('+').join(' ');
            parametros[key] = valor === 'null' ? null : valor;
    
            if (key === 'exercicios' || key === 'situacoes') {
                parametros[key] = Array.isArray(parametros[key]) ? parametros[key].map(Number) : [Number(parametros[key])];
            }
        });
        return parametros;
    }

    adicionar(){
        this.salvarEstadoPaginacao(this.listagem.pDatatableComponent.first);
        this.router.navigate(['./cadastrar'], { relativeTo: this.activatedRoute });
    }

    limpar() {
        this.filtro.reset();
    }
}



// WEBPACK FOOTER //
// ./src/app/base/base-list-filter.component.ts